// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-list {
  padding: 24px;
}
.testimonial-list .testimonial-header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.testimonial-header-container .testimonial-header {
  font-size: 2rem;
  font-weight: 600;
  font-family: Poppins;
}

/* --------------------------Global css------------------------- */

.testimonial .btn-flex .btn-container {
  margin-right: 20px;
}

.form_comp_checkbox {
  display: flex;
  align-items: center;
}

.form_comp_checkbox .label {
  width: 15%;
}

/* --------------------Testimonial-card---------------------- */
.testimonial-card-container {
  width: calc(25% - 20px);
  margin: 10px;
}

.testimonial-card-container .css-sgoict-MuiCardHeader-action {
  margin-top: 0px;
}

.faqs-error {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  color: #f53232;
}
`, "",{"version":3,"sources":["webpack://./src/features/Testimonial/Testimonial.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kEAAkE;;AAElE;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".testimonial-list {\n  padding: 24px;\n}\n.testimonial-list .testimonial-header-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.testimonial-header-container .testimonial-header {\n  font-size: 2rem;\n  font-weight: 600;\n  font-family: Poppins;\n}\n\n/* --------------------------Global css------------------------- */\n\n.testimonial .btn-flex .btn-container {\n  margin-right: 20px;\n}\n\n.form_comp_checkbox {\n  display: flex;\n  align-items: center;\n}\n\n.form_comp_checkbox .label {\n  width: 15%;\n}\n\n/* --------------------Testimonial-card---------------------- */\n.testimonial-card-container {\n  width: calc(25% - 20px);\n  margin: 10px;\n}\n\n.testimonial-card-container .css-sgoict-MuiCardHeader-action {\n  margin-top: 0px;\n}\n\n.faqs-error {\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 600;\n  color: #f53232;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
